<template>
  <!-- attributes all -->
  <div class="PageContent h-full w-7/12" style="margin: 100px auto">
    <!-- overview -->
    <div class="headtitle text-3xl pb-5">Maintainer</div>
    <div class="overview_content">
      <div class="pb-10">
        <div class="flex items-center">
          <div
            class="rounded-full h-2 w-2 bg-black mr-2"
            style="min-width: 8px; min-height: 8px"
          ></div>
          <i>Yuxuan Sun, Westlake University, [sunyuxuan@westlake.edu.cn]</i>
        </div>
        <div class="flex items-center">
          <div
            class="rounded-full h-2 w-2 bg-black mr-2"
            style="min-width: 8px; min-height: 8px"
          ></div>
          <i>
            Hao Wu, Macau University of Science and Technology,
            [2220024311@student.must.edu.mo]</i
          >
        </div>
        <div class="flex items-center">
          <div
            class="rounded-full h-2 w-2 bg-black mr-2"
            style="min-width: 8px; min-height: 8px"
          ></div>
          <i>
            Chenglu Zhu, Westlake University, [zhuchenglu@westlake.edu.cn]
          </i>
        </div>
      </div>
    </div>
    <div class="headtitle text-3xl pb-5 pt-5">Contact</div>
    <div class="overview_content">
      <div class="pb-24">
        Please contact us if you have any problems or suggestions.
      </div>
    </div>
    <div class="overview_content">
      <div class="text-2xl pb-5">Terms of use</div>
      <div class="pb-10">
        By using this project, users are required to agree to the following
        terms: The project is a research preview intended for
        <strong>non-commercial use only</strong>. It must not be used for any
        illegal, harmful, violent, racist, or sexual purposes. If you have any
        issues or suggestions, please contact us.
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.bg {
  background-color: #f5f5f5;
  color: rgba(0, 0, 0, 0.7);
}
.FeatureTitle {
  color: #6f6e6e;
  font-size: 27px;
}
.SubTitle {
  color: #6f6e6e;
  margin-top: 20px;
  font-size: 20px;
}
.subContent {
  font-size: 16px;
  color: #6f6e6e;
}
</style>
